import { Theme } from '@mui/material';

import { MessagingChannel } from '~hooks/useMessaging/models';
import { messagingChannelTitle } from '~pages/Messages/messagingChannelLabels';
import { Nullable } from '~types/Nullable';

// Brand hues are the same in both modes, so black initials stay readable on each of them.
const avatarColorsOf = (theme: Theme) => [
  theme.brandV2.colors.treadBlue2,
  theme.brandV2.colors.treadGreen,
  theme.brandV2.colors.treadOrange,
  theme.brandV2.colors.treadOrangeDark,
  theme.brandV2.colors.treadYellow,
];

export const messagingAvatarColorFor = (colorKey: string, theme: Theme) => {
  const avatarColors = avatarColorsOf(theme);
  const keyCharacterCodeTotal = [...colorKey].reduce(
    (total, character) => total + character.charCodeAt(0),
    0,
  );

  return avatarColors[keyCharacterCodeTotal % avatarColors.length];
};

export const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

type MessagingAvatarPerson = { colorKey: string; name: string };

export const messagingChannelCounterpart = (
  channel: MessagingChannel,
  viewerUserId: Nullable<string>,
): MessagingAvatarPerson => {
  const counterpart = channel.counterpartMember(viewerUserId);

  return {
    colorKey: counterpart?.principalId ?? channel.id,
    name: counterpart?.displayName ?? messagingChannelTitle(channel),
  };
};
